var _defs, _circle, _circle2, _path, _path2, _path3, _path4, _polygon, _path5, _polyline, _polygon2, _path6, _polyline2, _polygon3, _path7, _polyline3, _polygon4, _path8, _polyline4, _polygon5, _path9, _polyline5, _polygon6, _rect, _path10, _rect2, _rect3, _path11, _rect4, _rect5, _path12, _rect6, _rect7, _path13, _rect8, _rect9, _path14, _rect10, _rect11, _rect12, _path15, _rect13, _rect14, _rect15, _path16, _rect16, _rect17, _rect18, _path17, _rect19, _rect20, _rect21, _path18, _rect22, _rect23, _path19, _rect24, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPentagramma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 495.74 495.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#00573d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LOGO PENTAGRAMMA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.88,
    cy: 298.42,
    r: 241.82,
    transform: "translate(-173.97 247.36) rotate(-45)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 297.49,
    cy: 297.14,
    r: 243.55,
    transform: "translate(-172.6 248.12) rotate(-45)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M376.33,297.14a78.84,78.84,0,1,1-78.84-78.85A78.84,78.84,0,0,1,376.33,297.14Z",
    transform: "translate(-49.62 -49.27)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.49,395.16a98,98,0,1,1,98-98A98.13,98.13,0,0,1,297.49,395.16Zm0-190.86a92.84,92.84,0,1,0,92.84,92.84A92.95,92.95,0,0,0,297.49,204.3Z",
    transform: "translate(-49.62 -49.27)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M424.16,91c-59.88,0-76.58,54.7-127.82,54.7-58.15,0-67.94-53-128.4-54.7,0,0,57-38,128.4-38S424.16,91,424.16,91Z",
    transform: "translate(-49.62 -49.27)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M438,495.78c-91,0-87.52-49.51-138.76-49.51-61.61,0-56.43,50.09-143.94,50.09,0,0,69.67,44.91,141.06,44.91S438,495.78,438,495.78Z",
    transform: "translate(-49.62 -49.27)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "40.59 250.46 40.59 316.53 21.59 316.53 21.59 177.05 40.59 177.05 40.59 250.46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.89,296.57a5.18,5.18,0,1,1-5.18-5.19A5.18,5.18,0,0,1,85.89,296.57Z",
    transform: "translate(-49.62 -49.27)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "40.59 243.12 488.4 243.12 488.4 250.89 40.59 250.89"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "489.61 252.1 40.59 252.1 40.59 249.68 487.19 249.68 487.19 244.33 40.59 244.33 40.59 241.91 489.61 241.91 489.61 252.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.89,326.36a5.18,5.18,0,1,1-5.18-5.18A5.18,5.18,0,0,1,85.89,326.36Z",
    transform: "translate(-49.62 -49.27)"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "40.59 272.92 488.4 272.92 488.4 280.69 40.59 280.69"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "489.61 281.9 40.59 281.9 40.59 279.48 487.19 279.48 487.19 274.13 40.59 274.13 40.59 271.71 489.61 271.71 489.61 281.9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.89,356.16A5.18,5.18,0,1,1,80.71,351,5.18,5.18,0,0,1,85.89,356.16Z",
    transform: "translate(-49.62 -49.27)"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "40.59 302.71 482.35 302.71 482.35 310.49 40.59 310.49"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "483.56 311.69 40.59 311.69 40.59 309.28 481.14 309.28 481.14 303.92 40.59 303.92 40.59 301.5 483.56 301.5 483.56 311.69"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.89,266.77a5.18,5.18,0,1,1-5.18-5.18A5.18,5.18,0,0,1,85.89,266.77Z",
    transform: "translate(-49.62 -49.27)"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "40.59 213.32 488.4 213.32 488.4 221.1 40.59 221.1"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "489.61 222.31 40.59 222.31 40.59 219.89 487.19 219.89 487.19 214.53 40.59 214.53 40.59 212.12 489.61 212.12 489.61 222.31"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.89,237a5.18,5.18,0,1,1-5.18-5.18A5.18,5.18,0,0,1,85.89,237Z",
    transform: "translate(-49.62 -49.27)"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "40.59 183.53 483.65 183.53 483.65 191.3 40.59 191.3"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "484.86 192.51 40.59 192.51 40.59 190.09 482.44 190.09 482.44 184.74 40.59 184.74 40.59 182.32 484.86 182.32 484.86 192.51"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 118.29,
    y: 183.53,
    width: 25.48,
    height: 105.37
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.6,339.37H166.7V231.59h27.9ZM169.12,337h23.06V234H169.12Z",
    transform: "translate(-49.62 -49.27)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.81,
    y: 183.53,
    width: 12.96,
    height: 64.77
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 382.6,
    y: 202.96,
    width: 31.53,
    height: 99.75
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M465,353.19H431V251H465Zm-31.53-2.42h29.11V253.44H433.43Z",
    transform: "translate(-49.62 -49.27)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 382.17,
    y: 203.82,
    width: 14.68,
    height: 58.73
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 175.32,
    y: 221.1,
    width: 31.52,
    height: 99.75
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257.68,371.33h-34V269.16h34Zm-31.53-2.42h29.11V271.58H226.15Z",
    transform: "translate(-49.62 -49.27)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 175.32,
    y: 221.15,
    width: 14.25,
    height: 59.54
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 206.85,
    y: 191.3,
    width: 31.52,
    height: 110.55
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.2,352.33H255.26v-113H289.2Zm-31.52-2.42h29.1V241.78h-29.1Z",
    transform: "translate(-49.62 -49.27)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 224.12,
    y: 191.35,
    width: 14.25,
    height: 66.02
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 143.77,
    y: 173.19,
    width: 31.52,
    height: 99.75
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.13,323.42H192.18V221.25h33.95ZM194.6,321h29.11V223.67H194.6Z",
    transform: "translate(-49.62 -49.27)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 143.77,
    y: 173.24,
    width: 12.12,
    height: 59.54
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 163.06,
    y: 173.24,
    width: 12.12,
    height: 59.54
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 269.43,
    y: 190.94,
    width: 31.52,
    height: 94.48
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M351.76,335.86H317.88V239h33.88Zm-31.53-2.35H349.4V241.39H320.23Z",
    transform: "translate(-49.62 -49.27)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 269.43,
    y: 190.99,
    width: 12.12,
    height: 56.39
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 288.73,
    y: 190.99,
    width: 12.12,
    height: 56.39
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 237.91,
    y: 234.08,
    width: 31.52,
    height: 99.75
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M320.26,384.31H286.32V282.14h33.94Zm-31.52-2.42h29.11V284.55H288.74Z",
    transform: "translate(-49.62 -49.27)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 237.91,
    y: 234.13,
    width: 12.12,
    height: 59.54
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 257.2,
    y: 234.13,
    width: 12.12,
    height: 59.54
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 354.07,
    y: 173.19,
    width: 31.52,
    height: 99.75
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.43,323.42H402.49V221.25h33.94ZM404.9,321H434V223.67H404.9Z",
    transform: "translate(-49.62 -49.27)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 354.07,
    y: 173.24,
    width: 12.12,
    height: 59.54
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 373.37,
    y: 173.24,
    width: 12.12,
    height: 59.54
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 328.16,
    y: 156.35,
    width: 25.91,
    height: 104.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.9,311.33H376.58V204.41H404.9ZM379,308.91h23.5V206.83H379Z",
    transform: "translate(-49.62 -49.27)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 328.16,
    y: 156.4,
    width: 12.12,
    height: 59.54
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 301.39,
    y: 191.37,
    width: 27.66,
    height: 94.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M379.78,336.24H349.91v-96.7h29.87ZM352.12,334h25.45v-92.3H352.12Z",
    transform: "translate(-49.62 -49.27)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 301.39,
    y: 191.42,
    width: 10.64,
    height: 56.4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.13,408.2h4.33v27.12h-4.33Z",
    transform: "translate(-49.62 -49.27)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.4,408.2h4.34v23.48h10.48v3.64H178.4Z",
    transform: "translate(-49.62 -49.27)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.17,408.2h8.59c5.2,0,7.48,3.26,7.48,7.9,0,4.86-2.85,8-7.94,8h-3.8v11.2h-4.33Zm4.33,12.65h3.08c2.32,0,4.33-1.26,4.33-4.68,0-2.92-1.18-4.71-4.63-4.71H211.5Z",
    transform: "translate(-49.62 -49.27)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.31,408.2H242v3.64H231.64v7.53h9.73V423h-9.73v8.67h10.64v3.64h-15Z",
    transform: "translate(-49.62 -49.27)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.73,408.2H252l7.86,20.21H260V408.2h4.1v27.12h-5.28l-7.86-20.74h-.08v20.74h-4.1Z",
    transform: "translate(-49.62 -49.27)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.13,411.84h-6.46V408.2H284.8v3.64h-6.34v23.48h-4.33Z",
    transform: "translate(-49.62 -49.27)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.46,408.2H297l7.14,27.12h-4.52L298,428.67H290l-1.75,6.65h-4.52Zm5.77,17-3.12-13.38H294l-3.23,13.38Z",
    transform: "translate(-49.62 -49.27)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M320.6,432.17h-.08c-1.17,2.51-2.73,3.69-5.92,3.69-5.93,0-8.06-4.41-8.06-14.1s2.74-14.1,9-14.1c6.8,0,7.94,5.36,7.94,7.83v.5h-4.11v-.65c0-2-.83-4.41-3.8-4.41s-4.71,2.05-4.71,10.72,1.45,10.94,4.37,10.94c3.31,0,4.52-2.36,4.52-8.28h-4.55V421h8.66v14.28H320.6Z",
    transform: "translate(-49.62 -49.27)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M328.73,408.2h9.58c3.8,0,6.88,1.9,6.88,7,0,3.49-1.56,6.19-4.53,6.65v.07c2.7.27,4.11,1.75,4.26,5.55,0,1.75.08,3.87.15,5.51a2.8,2.8,0,0,0,1.29,2.35h-4.9a4.51,4.51,0,0,1-.72-2.39c-.15-1.63-.11-3.15-.19-5.13-.08-3-1-4.25-3.95-4.25h-3.53v11.77h-4.34Zm7.79,12.08c2.78,0,4.33-1.67,4.33-4.41s-1.25-4.41-4.1-4.41h-3.68v8.82Z",
    transform: "translate(-49.62 -49.27)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M355.41,408.2H361l7.14,27.12h-4.52l-1.67-6.65h-8l-1.74,6.65H347.7Zm5.77,17-3.11-13.38H358l-3.23,13.38Z",
    transform: "translate(-49.62 -49.27)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M371.14,408.2h6.77l4.78,20.09h.08l4.71-20.09h6.61v27.12H390V412.76h-.08l-5.47,22.56h-3.65l-5.47-22.56h-.07v22.56h-4.11Z",
    transform: "translate(-49.62 -49.27)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M399.72,408.2h6.76l4.79,20.09h.07l4.72-20.09h6.61v27.12h-4.11V412.76h-.07L413,435.32h-3.65l-5.47-22.56h-.08v22.56h-4.1Z",
    transform: "translate(-49.62 -49.27)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M433.42,408.2H439l7.14,27.12h-4.52l-1.67-6.65H432l-1.75,6.65h-4.52Zm5.78,17-3.12-13.38H436l-3.23,13.38Z",
    transform: "translate(-49.62 -49.27)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.49,545A247.87,247.87,0,0,1,122.22,121.87,247.87,247.87,0,1,1,472.76,472.41,246.24,246.24,0,0,1,297.49,545Zm0-487.1A239.23,239.23,0,0,0,128.33,466.3,239.23,239.23,0,1,0,466.65,128,237.63,237.63,0,0,0,297.49,57.91Z",
    transform: "translate(-49.62 -49.27)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPentagramma);
export default __webpack_public_path__ + "static/media/logo-pentagramma.29a36075220bc4cc42fab1687043ce71.svg";
export { ForwardRef as ReactComponent };